











import Vue from 'vue'

export default Vue.extend({
  // lang属性を現在のロケールに連動させる
  head(): { htmlAttrs: { lang: string } } {
    return { htmlAttrs: { lang: this.$i18n.locale } }
  },
})
